// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import uuidv4 from 'uuid/v4';
import history from '../../../services/history';

import { getTotal } from '../../basket/store/selectors';
import * as basketActions from '../../basket/store/actions';
import { getPaymentType } from '../../choose-delivery/store/selectors';
import * as chooseDeliveryActions from '../../choose-delivery/store/actions';
import * as parcelShopsActions from '../store/actions';
import { getPostcode, getParcelShops } from '../store/selectors';
import { MyMap } from '../components';
import { Stepper } from '../../choose-delivery/components';
import PaperLayout from '../../../components/PaperLayout/PaperLayout';
import styles from './styles';
import { Input, Button } from '../../../components';

class FindParcelShopPage extends React.Component {
  state = {};

  componentDidMount() {
    this.props.requestParcelShops();
    this.props.requestBasket(localStorage.getItem('CartID'));
  }

  searchParcelShops = () => {
    const { requestParcelShops, postcode } = this.props;
    requestParcelShops(postcode);
  }

  onComplete = () => {
    const CustomerId = localStorage.getItem('loggedID');
    const CartID = localStorage.getItem('CartID');
    const Token = localStorage.getItem('token');
    const { paymentType } = this.props;
    if (CustomerId && CartID) {
      this.props.requestConfirm({
        CustomerId,
        CartID,
        Token,
        paymentType,
        total: this.props.total,
      });
    }
    history.push({
      pathname: '/confirmed-collection',
      state: { from: 'parcel-shop' }
    });
  }

  render() {
    const { classes, postcode, parcelShops } = this.props;
    const text = [{
      text: 'To find your nearest ',
      bold: false,
    }, {
      text: 'Evri',
      bold: true,
    }, {
      text: ` enter your postcode in the field below, if you can't find a Evri
      near to you, please  `,
      bold: false,
    }, {
      text: 'contact us.',
      bold: true,
      link: '/contact',
    }];

    return (
      <PaperLayout hasSubPaper={false} label={'SEND YOUR ITEMS'}>
        <div className={classes.mainContainer}>
          <Stepper />
          <div className={classes.descriptionContainer}>
            {text.map(el => (
              <span
                key={uuidv4()}
                className={classNames(classes.text,
                  el.bold ? classes.boldText : null)}
              >
                {!el.link ? el.text : <Link className={classes.link} to={el.link}>{el.text}</Link>}
              </span>))}
          </div>
          <div className={classes.mapContainer}>
            <div className={classes.postcodeContainer}>
              <Input
                placeholder={'Postcode'}
                value={postcode}
                name={'postcode'}
                onChange={this.props.changeField}
              />
              <Button
                text={'SEARCH'}
                onPress={this.searchParcelShops}
              />
            </div>
            <MyMap shops={parcelShops} />
            <Button
              style={classes.completeButton}
              onPress={this.onComplete}
              text={'COMPLETE'}
            />
          </div>
        </div>
      </PaperLayout>
    );
  }
}

FindParcelShopPage.propTypes = {
  classes: PropTypes.object,
  postcode: PropTypes.string,
  changeField: PropTypes.func,
  requestParcelShops: PropTypes.func,
  parcelShops: PropTypes.array,
  requestConfirm: PropTypes.func,
  requestBasket: PropTypes.func,
  paymentType: PropTypes.number,
  total: PropTypes.object,
};
FindParcelShopPage.defaultProps = {
  classes: {},
  postcode: null,
  changeField: () => { },
  requestParcelShops: () => { },
  requestConfirm: () => { },
  requestBasket: () => { },
  parcelShops: [],
  paymentType: PropTypes.number,
  total: {},
};

const mapStateToProps = (state) => {
  return {
    postcode: getPostcode(state),
    parcelShops: getParcelShops(state),
    paymentType: getPaymentType(state),
    total: getTotal(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeField: (value, name) => dispatch(parcelShopsActions.changeField(value, name)),
    requestParcelShops: postcode => dispatch(parcelShopsActions.getParcelShops(postcode)),
    requestConfirm: data => dispatch(chooseDeliveryActions.requestConfirm(data)),
    requestBasket: id => dispatch(basketActions.requestBasket(id)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(FindParcelShopPage));
